import {
  GET_BUYERS_TRADED_AMOUNTS,
  GET_BUYERS_TRADED_AMOUNTS_ERROR,
  GET_BUYERS_TRADED_AMOUNTS_SUCCESS
} from './BuyersTradedAmountsSection.actions'

const buyersTradedAmountsSectionState = {
  csv: [],
  data: [],
  error: null,
  loading: false
}

/**
 * The buyers traded amounts section's reducer.
 */
const buyersTradedAmountsSectionReducer = (state = buyersTradedAmountsSectionState, { payload, type }) => {
  switch (type) {
    case GET_BUYERS_TRADED_AMOUNTS: {
      return { ...state, loading: true }
    }
    case GET_BUYERS_TRADED_AMOUNTS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_BUYERS_TRADED_AMOUNTS_SUCCESS: {
      return { ...state, csv: payload.csv, data: payload.data, loading: false }
    }
    default: {
      return state
    }
  }
}

export default buyersTradedAmountsSectionReducer
